import { isFinanceProject, isGlobalProject } from 'config';
import { applySchema } from 'helpers';
import {
  TypedForm,
  FormErrors as FormErrorsBase,
  ObjectSchema,
  object,
} from 'libs/form';
import { TFunc } from 'libs/i18n';
import {
  AdditionalDocumentsFormType,
  getAdditionalDocumentsSchema,
} from 'modules/client/common/forms/additionalDocumentsForm';
import {
  DocumentsFormType,
  documentsSchema,
} from 'modules/client/common/forms/documentsForm';
import {
  ReasonChangeFormType,
  reasonChangeSchema,
} from 'modules/client/common/forms/reasonChangeForm';

import { BaseActivityFormType, baseActivitySchema } from './baseActivityForm';
import { CitizenshipFormType, citizenshipsSchema } from './citizenshipForm';
import { ContactsFormType, getContactsSchema } from './contactsForm';
import { ControlOverFormType, getControlOverSchema } from './controlOverForm';
import {
  IdentityDocumentFormType,
  identityDocumentSchema,
} from './identityDocumentForm';
import {
  PepConnectionFormType,
  getPepConnectionSchema,
} from './pepConnectionForm';
import {
  PersonalDataFormType,
  getPersonalDataSchema,
} from './personalDataForm';
import { PlaceOfBirthFormType, placeOfBirthSchema } from './placeOfBirthForm';
import {
  RegistrationAddressFormType,
  registrationAddressSchema,
} from './registrationAddressForm';
import {
  ResidentialAddressFormType,
  residentialAddressWithFilesSchema,
} from './residentialAddressForm';
import {
  TaxResidencyFormType,
  getTaxResidencesSchema,
} from './taxResidencyForm';

export interface LegalClientBeneficiaryFormType
  extends BaseActivityFormType,
    ContactsFormType,
    PersonalDataFormType,
    CitizenshipFormType,
    TaxResidencyFormType,
    PlaceOfBirthFormType,
    RegistrationAddressFormType,
    ResidentialAddressFormType,
    PepConnectionFormType,
    IdentityDocumentFormType,
    ControlOverFormType,
    DocumentsFormType,
    AdditionalDocumentsFormType,
    ReasonChangeFormType {}

export const getSchema = (
  t: TFunc
): ObjectSchema<LegalClientBeneficiaryFormType> => {
  const isGlobal = isGlobalProject();
  const isFinance = isFinanceProject();
  return object()
    .concat(baseActivitySchema)
    .concat(citizenshipsSchema)
    .concat(getTaxResidencesSchema())
    .concat(applySchema(!isGlobal, registrationAddressSchema))
    .concat(residentialAddressWithFilesSchema)
    .concat(placeOfBirthSchema)
    .concat(
      getControlOverSchema({
        enabledControlOverLegalClientStatus: isGlobal,
        enabledFinancialConditionAmount: isFinance,
        enabledHasControlOverLegalClient: isFinance,
      })
    )
    .concat(identityDocumentSchema)
    .concat(getContactsSchema(t))
    .concat(getPersonalDataSchema(t))
    .concat(getPepConnectionSchema(t, { notRequestInformation: isGlobal }))
    .concat(documentsSchema)
    .concat(reasonChangeSchema)
    .concat(getAdditionalDocumentsSchema());
};

export const { Field, Form, useFormContext, Submit } =
  TypedForm<LegalClientBeneficiaryFormType>();

export type FormErrors = FormErrorsBase<LegalClientBeneficiaryFormType>;
